import React, {useContext, useEffect, useState} from 'react';
import TablePage from "./Pages/TablePage/TablePage";
import {useHttp} from "../hooks/http.hook";
import {AuthContext} from "../context/AuthContext";
import PropTypes from 'prop-types'
import {observer} from "mobx-react";
import {useAPI} from "../hooks/useAPI";

const OrgPage = observer((props) => {
    const {request, loading} = useHttp()
    const {APIRequest} = useAPI()
    const {token} = useContext(AuthContext)
    const [data, setData] = useState([])
    const [limit, setLimit] = useState(20)
    const [filterOptions, setFilterOptions] = useState('')
    const [sortBy, setSortBy] = useState(props.defaultSortBy || {name: 'fio', method: true, ready: ''})

    const [pagination, setPagination] = useState({
        limit: 20,
        resultsCount: 0,
        offset: 1,
        allPages: 2
    })

    const sortHandler = (name) => {
        setSortBy({method: !sortBy.method, name: name})
    }

    const toBegin = () => {
        //Функция отвечает за то, чтобы при применении фильтрации, таблица уходила в начало.
        let a = document.createElement('a')
        a.href = '#first-row'
        a.click()
        window.history.back()
    }

    function offsetHandler(offset) {
        setPagination({...pagination, offset: offset})
    }

    const filterHandler = (e) => {
        setFilterOptions(e)
        offsetHandler(1)
    }
    const getData = async (filterData, limit, offset) => {
        const url = `${props.url}${filterData}${'limit=' + limit + '&'}${'offset=' + offset + '&'}` + 'orderBy=' + JSON.stringify({[sortBy.name]: sortBy.method ? 1 : -1})
        const {data, status} = await request(url, 'GET', null, {Authorization: `Bearer ${token.token}`})
        setData([])

        if (status === 200) {
            if (data) {
                setData(data.data)
            }
            data.pagination && setPagination({...pagination, resultsCount: data.pagination.resultsCount})
            data.payload && setPagination({...pagination, resultsCount: data.payload.resultsCount})
        }
    }
    const exportHandler = async () => {
        const url = `${props.exportTemplateButtons.exportUrl}${filterOptions}`
        return await APIRequest({api: url, method: "GET"}, null)
    }

    const registryHandler = async () => {
        const url = `${props.exportTemplateButtons.registryUrl}${filterOptions}`
        return await APIRequest({api: url, method: "GET"}, null)
    }

    const printHandler = async () => {
        const url = `${props.exportTemplateButtons.printUrl}${filterOptions}`
        return await APIRequest({api: url, method: "GET"}, null)
    }


    const exportTemplateButtons = {
        ...props.exportTemplateButtons,
        onExport: exportHandler, onRegistry: registryHandler, onPrint: printHandler
    }
    useEffect(() => {
        setPagination({...pagination, limit: parseInt(limit), offset: 1})
    }, [limit])

    useEffect(() => {
        //Срабатывает каждый раз, когда меняеются параметры пагинации
        getData(filterOptions, pagination.limit, pagination.offset)
        toBegin()
    }, [filterOptions, pagination.offset, pagination.limit, sortBy, props.refresh])

    return (

        <TablePage pageName={'TablePage'}
                   loading={loading}
                   filterComponent={props.filterComponent}
                   tableFirstRow={props.firstRow}
                   tableHaveToShow={props.haveToShow}
                   tableStorage={data}
                   tableTitle={''}
                   sortHandler={sortHandler}
                   filterChangeURL={e => filterHandler(e)}
                   showCountChanger={setLimit}
                   setActualPage={e => offsetHandler(e)}
                   breadCrumbsItems={props.breadCrumbsItems}
                   filterFieldsConf={props.filterFieldsConf}
                   pagination={pagination}
                   filterBarButtons={props.filterBarButtons}
                   addOrg={props.addOrg}
                   exportTemplateButtons={exportTemplateButtons}
        />
    );
})
export default OrgPage;

OrgPage.propTypes = {
    breadCrumbsItems: PropTypes.array,
    firstRow: PropTypes.array,
    haveToShow: PropTypes.array,
    tableStorage: PropTypes.array,
    filterChangeURL: PropTypes.func,
    showCountChanger: PropTypes.func,
    setActualPage: PropTypes.func,
    pagination: PropTypes.object,
    addOrg: PropTypes.object,
    defaultSortBy: PropTypes.shape({
        name: PropTypes.string,
        method: PropTypes.bool,
        ready: PropTypes.string
    }),
    exportTemplateButtons: PropTypes.shape({
        export: PropTypes.bool,
        onExport: PropTypes.func,
        registry: PropTypes.any,
        onRegistry: PropTypes.any
    })
}

OrgPage.defaultProps = {
    addOrg: {
        show: false,
        onClick: () => {
        }
    },
    exportTemplateButtons: {
        export: false,
        registry: false,
    },
    filterBarButtons: {
        show: true,
        onClick: () => {
        },

        downloadTemplate: {
            show: true,
            url: '/'
        }

    },

}